/**
 * Friends tab stack – list, friend stats, group leaderboard.
 * Enables back = pop (no full reload) when leaving group leaderboard.
 * On web (including mobile web), pressing the Friends tab again pops to friends list.
 */

import { useEffect } from 'react'
import { Stack, useNavigation, useRouter } from 'expo-router'
import { StackActions } from '@react-navigation/native'

export default function FriendsStackLayout() {
  const navigation = useNavigation()
  const router = useRouter()

  useEffect(() => {
    const parent = navigation.getParent()
    if (!parent) return
    const unsubscribe = parent.addListener(
      'tabPress' as Parameters<typeof parent.addListener>[0],
      () => {
        navigation.dispatch(StackActions.popToTop())
        router.replace('/app/friends' as never)
      }
    )
    return unsubscribe
  }, [navigation, router])

  return <Stack screenOptions={{ headerShown: false }} />
}
